import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { deleteCompanyUser } from "../Store/Thunk";
import { companyUserEnum, GetKeyByValue } from "../../../../../Helpers/EnumHelper";
import { FetchSelectedCompanyUserData, updateChangePasswordModalData } from "../Store";
import {
  AdminListCard,
  AdminListMain,
  AdminActions,
  AdminButton,
  ConfirmDeleteButton,
} from "../../../SharedComponents/ListView";

export default function CompanyUserList({ setSelectedCompanyUserName }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const companyUserList = useSelector((state) => state.companyUser.companyUserList);

  const HandleUpdateButton = (companyUser) => {
    setSelectedCompanyUserName(companyUser.name);
    dispatch(FetchSelectedCompanyUserData({ companyUser }));
  };

  const HandleChangePasswordButton = (email) => {
    dispatch(updateChangePasswordModalData({ variableName: "isShown", value: true }));
    dispatch(updateChangePasswordModalData({ variableName: "email", value: email }));
  };

  return (
    companyUserList &&
    companyUserList.map((companyUser, i) => (
      <AdminListCard key={"companyUser" + i} tag={companyUser.tag}>
        <AdminListMain>
          <span className="admin-list-id">{companyUser.id}</span>
          <span className="admin-list-title">{companyUser.name}</span>
          <span className="admin-list-meta">{companyUser.email}</span>
          <span className="admin-list-meta">{companyUser.phoneNumber}</span>
          <span className="admin-list-meta">
            {GetKeyByValue(companyUser.companyUserTypeEnum, companyUserEnum)}
          </span>
        </AdminListMain>
        <AdminActions>
          <AdminButton variant="warning" onClick={() => HandleChangePasswordButton(companyUser.email)}>
            {t("changePasswordButtonLabel")}
          </AdminButton>
          <AdminButton variant="outline" onClick={() => HandleUpdateButton(companyUser)}>
            {t("updateButtonLabel")}
          </AdminButton>
          <ConfirmDeleteButton
            label={t("deleteButtonLabel")}
            onConfirm={() => dispatch(deleteCompanyUser({ companyUserId: companyUser.id, userId: companyUser.applicationUserId }))}
          />
        </AdminActions>
      </AdminListCard>
    ))
  );
}
